import type { Routes } from '@angular/router';
import { legalDocResolver } from './legal-doc.resolver';
import { PageLayout } from 'src/app/layout/layout.enum';

const defaultPageOptions = {
  pageProvider: '',
  name: '',
  type: '',
  pageType: PageLayout.Default,
  extraData: {
    title: '',
    id: '',
    path: '',
    components: {
      global: true,
      advantage: true,
      footer: true,
      header: true,
      globalTimer: false,
      newsletter: true,
      breadcrumbs: true,
      customComponents: null,
    },
  },
};

export const legalsComponentRoutes: Routes = [
  {
    path: 'docs/:pageId',
    loadComponent: () => import('./legals.component').then((m) => m.AppLegalsComponent),
    data: {
      breadcrumb: 'Legals',
      page: defaultPageOptions,
    },
    resolve: {
      docInfo: legalDocResolver,
    },
  },
];
